import gql from 'graphql-tag';

const addOnboardingQueueNoteMutation = gql`
  mutation AddOnboardingQueueNote($input: AddOnboardingQueueNoteInput!) {
    addOnboardingQueueNote(input: $input) {
      success
      errors
      onboardingQueueRecord {
        flatRateOfferId
        status
        reason
        noteCount
        updatedAt
        updatedBy
        notes {
          id
          note
          createdBy
          createdAt
        }
      }
    }
  }
`;

export default addOnboardingQueueNoteMutation;
